import { IconProps } from "./Icon.model";

export function AddCommentIcon({ size = 16, fill = "currentColor" }: IconProps) {
  const fillColor =
    fill === "currentColor" ? "var(--slate-11)" : `var(--${fill}-8)`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.75 3.41667H14.0833M11.4167 0.75L11.4167 6.08333"
        stroke={fillColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.48254 12.416C2.6158 12.3308 1.9665 12.0704 1.53105 11.635C0.75 10.8539 0.75 9.59684 0.75 7.08268V6.74935C0.75 4.23519 0.75 2.97811 1.53105 2.19706C2.3121 1.41602 3.56918 1.41602 6.08333 1.41602H7.08333M3.75 11.416C3.61303 12.0839 3.0018 13.527 3.62713 13.9928C3.954 14.2305 4.47486 13.9766 5.51658 13.4686C6.24768 13.1121 6.98748 12.7033 7.7864 12.5194C8.07876 12.4528 8.37636 12.4243 8.75 12.416C11.2642 12.416 12.5212 12.416 13.3023 11.635C14.048 10.8892 14.0817 9.70952 14.0833 7.41602"
        stroke={fillColor}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M4.75 8.74935H8.75M4.75 5.41602H6.75"
        stroke={fillColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

